export enum DETECTUM_SERVICES {
    AUTOSUGGEST = 'autosuggest',
    SEARCH = 'search'
}

const detectumConfig = {
    production: {
        [DETECTUM_SERVICES.SEARCH]: {
            de: 'https://api.eu.detectum.com/lehrermarktplatz/search/search_plain',
            es: 'https://api.eu.detectum.com/eduki_es/search/search_plain',
            fr: 'https://api.eu.detectum.com/eduki_fr/search/search_plain',
            gr: 'https://api.eu.detectum.com/eduki_gr/search/search_plain',
            it: 'https://api.eu.detectum.com/eduki_it/search/search_plain'
        },
        [DETECTUM_SERVICES.AUTOSUGGEST]: {
            de: 'https://api.eu.detectum.com/lehrermarktplatz/suggest/rich',
            es: 'https://api.eu.detectum.com/eduki_es/suggest/rich',
            fr: 'https://api.eu.detectum.com/eduki_fr/suggest/rich',
            gr: 'https://api.eu.detectum.com/eduki_gr/suggest/rich',
            it: 'https://api.eu.detectum.com/eduki_it/suggest/rich'
        }
    },
    staging: {
        [DETECTUM_SERVICES.SEARCH]: {
            de: 'https://delta.detectum.com/lehrermarktplatz/search/search_plain',
            es: 'https://delta.detectum.com/eduki_es/search/search_plain',
            fr: 'https://delta.detectum.com/eduki_fr/search/search_plain',
            gr: 'https://delta.detectum.com/eduki_gr/search/search_plain',
            it: 'https://delta.detectum.com/eduki_it/search/search_plain'
        },
        [DETECTUM_SERVICES.AUTOSUGGEST]: {
            de: 'https://delta.detectum.com/lehrermarktplatz/suggest/rich',
            es: 'https://delta.detectum.com/eduki_es/suggest/rich',
            fr: 'https://delta.detectum.com/eduki_fr/suggest/rich',
            gr: 'https://delta.detectum.com/eduki_gr/suggest/rich',
            it: 'https://delta.detectum.com/eduki_it/suggest/rich'
        }
    }
};

export default detectumConfig;
